import { render, staticRenderFns } from "./HistoricalAlarmOrder.vue?vue&type=template&id=8b8a5e2a&scoped=true&"
import script from "./HistoricalAlarmOrder.vue?vue&type=script&lang=js&"
export * from "./HistoricalAlarmOrder.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalAlarmOrder.vue?vue&type=style&index=0&id=8b8a5e2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8a5e2a",
  null
  
)

export default component.exports